var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"loading-animation",class:_vm.wrapClasses},[_c('div',{staticClass:"loading-animation-inner"},[_c('i',{staticClass:"loading-animation-icon",class:_vm.iconClasses})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }